/* FFL CUSTOM (hero-slider 2026-05-31) — auto-playing room-scene slider
   Pauses on hover, advances every 4s, supports arrow + dot navigation. */
(function () {
  'use strict';
  var INTERVAL = 4000;

  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ffl-hero__slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ffl-hero__slider-dot'));
    var idx = 0, timer = null;

    function show(n) {
      idx = (n + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === idx);
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === idx);
      }
    }
    function next() { show(idx + 1); }
    function prev() { show(idx - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); timer = setInterval(next, INTERVAL); }

    var nextBtn = root.querySelector('[data-slider-next]');
    var prevBtn = root.querySelector('[data-slider-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); prev(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        show(parseInt(d.getAttribute('data-dot-index'), 10) || 0);
        start();
      });
    });
    /* hover handlers moved below, so that leaving the slider cannot restart it
       while the user has explicitly pressed pause (external audit item 36) */

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else if (!paused) start();
    });

    /* FFL CUSTOM (external audit item 36, 2026-09-20)
       Hover-to-pause helps a mouse user and nobody else. Keyboard and touch users had no way to
       stop content changing under them every 4s. Three things are added:
         - a real pause/play button in the DOM, 44x44, labelled and reflected in aria-pressed
         - focus anywhere inside the slider pauses it; leaving resumes (unless explicitly paused)
         - prefers-reduced-motion: no autoplay at all, per the user's OS setting  */
    var paused = false;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ffl-hero__slider-playpause';
    toggle.setAttribute('data-slider-playpause', '');
    function paintToggle() {
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Play the slideshow' : 'Pause the slideshow');
      toggle.textContent = paused ? '▶' : '⏸';
    }
    toggle.addEventListener('click', function () {
      paused = !paused;
      if (paused) stop(); else start();
      paintToggle();
    });
    root.appendChild(toggle);

    // keyboard users: pause while focus is inside the slider
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!paused && !root.contains(e.relatedTarget)) start();
    });

    // hover should not override an explicit pause
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { if (!paused) start(); });

    show(0);
    if (reduceMotion && reduceMotion.matches) {
      paused = true;            // honour the OS setting: start stopped
    } else {
      start();
    }
    paintToggle();

    if (reduceMotion && reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function (e) {
        paused = e.matches;
        if (paused) stop(); else start();
        paintToggle();
      });
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ffl-hero-slider]');
    nodes.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
